export default {
  authorizedRedirections: [
    /^\/$/,
    /^\/onegeo-publish/,
    /^\/onegeo-login/,
    /^\/onegeo-maps/,
    /^\/portail/,
    /^\/public/,
    /^\/chat/,
    /^\/oidc/,
  ],
  client: {
    name: "PIGMA",
    email: "pigma@gipatgeri.fr",
    warning: false
  },
  customHeaderAndFooter: false,
  personalDataExport: true,
  forms: {
    signin: {
      title: {
        en: "Enter your login",
        fr: "Saisissez vos identifiants",
      }
    },
    signup: {
      disabled: false,
      hiddenFields: [],
      requiredFields: [
        'first_name',
        'last_name',
        'email',
      ],
    },
    organisation: {
      hiddenFields: [],
      requiredFields: [
        'display_name',
        'organisation_type',
      ],
    },
  },
};
